import React, { PureComponent } from 'react'
import { createContainer } from '@dbk-legacy/muster/react'
import Text from '@dbk/ui-text'
import admin from '../../../data/admin.json'
import { AlertManegement, AppAnalytics } from '../../common/icons'
import { Contract } from '@dbk/ui-icons'
class AppAdminBody extends PureComponent {
  constructor(props) {
    super(props)
    this.renderAssetItem = this.renderAssetItem.bind(this)
    this.alertManegement = this.alertManegement.bind(this)
    this.openDocumentCenter = this.openDocumentCenter.bind(this)
  }

  alertManegement(rsaAuthorised, webssoEnabled) {
    if (webssoEnabled) {
      this.props.changePage('/admin/alertlist')
    } else {
      this.props.rsaChangePage('/admin/alertlist')
    }
  }
  openDocumentCenter(rsaAuthorised, webssoEnabled) {
    if (webssoEnabled) {
      this.props.changePage('/docsigncenter')
    } else {
      this.props.rsaChangePage('/docsigncenter')
    }
  }
  renderAssetItem(opt) {
    const { key, title } = opt
    const {
      rsa: { rsaAuthorised },
      webssoauthentication: { webssoEnabled },
      auth: { entitlement },
    } = this.props
    if (key === 'alertMessageManagement') {
      return (
        <div className="columns small-12 medium-4">
          <div
            className="admin-selection"
            onClick={() => this.alertManegement(rsaAuthorised, webssoEnabled)}
          >
            <div>
              <AlertManegement width={40} height={40} color={'#ffffff'} />
            </div>
            <Text secondary>{title}</Text>
          </div>
        </div>
      )
    } else if (key === 'documentCentre') {
      return (
        <div className="columns small-12 medium-4">
          <div
            className={entitlement.esign_rmops ? 'admin-selection' : 'admin-selection disabled'}
            onClick={() => {
              entitlement.esign_rmops ? this.openDocumentCenter(rsaAuthorised, webssoEnabled) : ' '
            }}
          >
            <div>
              <Contract width={40} height={40} color={'#ffffff'} />
            </div>
            <Text secondary>{title}</Text>
          </div>
        </div>
      )
    } else if (key === 'appUsageAnalytics') {
      return (
        <div className="columns small-12 medium-4">
          <div className="admin-selection disabled">
            <div>
              <AppAnalytics width={40} height={40} color={'#ffffff'} />
            </div>
            <Text secondary>{title}</Text>
          </div>
        </div>
      )
    }
  }

  render() {
    const { auth } = this.props
    const adminList = admin.admin
    const rowMarkerStyle = { fill: 'transparent' }
    return (
      <div className="scene profile-container">
        <div className="row">{adminList.map(opt => this.renderAssetItem(opt))}</div>
      </div>
    )
  }
}

export default createContainer({
  $queries: {
    rsaChangePage: { $call: 'rsa.changePage' },
    auth: {
      onLogout: { $call: 'logout' },
      lastSession: true,
      entitlement: true,
    },
    rsa: {
      rsaAuthorised: true,
    },
    webssoauthentication: {
      webssoEnabled: true,
    },
    changePage: { $call: 'ui.history.push' },
  },
})(AppAdminBody)